/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const AllNotifications = loadable(() => import('./AllNotifications'), {
  fallback: <LoadingIndicator />,
});

export const OwnNotifications = loadable(() => import('./OwnNotifications'), {
  fallback: <LoadingIndicator />,
});
